import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import "../../assets/css/recommendation-modal.css";
// import { Link  , useParams} from "react-router-dom";
import { getSubDomainDetails, getSubDomainDetailsTotal, addSubdomains, getSubDomainDetailsGraph, getSubDomainDetailsAction } from "../../actions/sub-domain";
import moment from "moment";
import Pagination from "../Pagination/Pagination";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import BasicLineColumn from "../common/apexChart/lineChart";
import ScanMessage from "../common/scanningMessage";
import AccessPage from "../Shared/accessPage";
import axios from "axios";
import { toastr } from "react-redux-toastr";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { Link, useParams } from "react-router-dom";
import $, { data } from "jquery";
import PieChart from "../../components/common/dashboard12/piechart.js";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format, isValid } from "date-fns";

const sliderStyles = `
  body.details-slider-open {
    overflow: hidden;
  }
  
  .details-slider-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1040;
    opacity: 0;
    transition: opacity 0.3s ease;
    pointer-events: none;
  }
  
  .details-slider-overlay.show {
    opacity: 1;
    pointer-events: all;
  }
  
  .details-slider-panel {
    position: fixed;
    top: 0;
    right: -600px;
    width: 600px;
    max-width: 90vw;
    height: 100%;
    background: #ffffff;
    box-shadow: -4px 0 20px rgba(0, 0, 0, 0.3);
    z-index: 1050;
    transition: right 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    overflow: hidden;
    display: flex;
    flex-direction: column;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  
  .details-slider-panel.open {
    right: 0;
  }
  
  .details-slider-content {
    background: #ffffff;
    height: 100%;
    min-height: 100%;
    max-height: 100%;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    box-sizing: border-box;
  }
  
  .details-slider-header {
    background: #453acd;
    color: white;
    padding: 15px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    flex-shrink: 0;
  }
  
  .details-slider-header h5 {
    margin: 0;
    font-size: 1.1rem;
    font-weight: 600;
  }
  
  .details-slider-close {
    background: rgba(255, 255, 255, 0.2);
    border: none;
    color: white;
    width: 30px;
    height: 30px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s ease;
    font-size: 18px;
  }
  
  .details-slider-close:hover {
    background: rgba(255, 255, 255, 0.3);
  }
  
  .details-slider-action-btn {
    background: rgba(255, 255, 255, 0.15);
    border: 1px solid rgba(255, 255, 255, 0.3);
    color: white;
    padding: 8px 16px;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    font-weight: 500;
    white-space: nowrap;
    outline: none;
  }
  
  .details-slider-action-btn:hover {
    background: rgba(255, 255, 255, 0.25);
    border-color: rgba(255, 255, 255, 0.5);
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  }
  
  .details-slider-action-btn:active {
    transform: translateY(0);
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  }
  
  .details-slider-action-btn i {
    font-size: 14px;
    color: white;
  }
  
  .details-slider-action-btn-text {
    color: white;
  }
  
  .details-slider-tabs {
    display: flex;
    background: #f8f9fa;
    border-bottom: 1px solid #dee2e6;
    flex-shrink: 0;
  }
  
  .details-slider-tab {
    flex: 1;
    padding: 12px 20px;
    background: transparent;
    border: none;
    border-bottom: 3px solid transparent;
    color: #495057;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
  }
  
  .details-slider-tab:hover {
    background: #e9ecef;
    color: #453acd;
  }
  
  .details-slider-tab.active {
    background: #ffffff;
    color: #453acd;
    border-bottom-color: #453acd;
  }
  
  .details-slider-body {
    padding: 20px;
    overflow-y: auto;
    flex: 1;
  }
  
  .details-section {
    background: #ffffff;
    border: 1px solid #dee2e6;
    border-radius: 4px;
    padding: 15px;
    margin-bottom: 15px;
  }
  
  .details-section-title {
    font-size: 1rem;
    font-weight: 600;
    color: #212529;
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    gap: 8px;
    padding-bottom: 10px;
    border-bottom: 1px solid #dee2e6;
  }
  
  .details-section-title i {
    color: #453acd;
    font-size: 1rem;
  }
  
  .details-info-item {
    display: flex;
    padding: 8px 0;
    border-bottom: 1px solid #f1f3f5;
  }
  
  .details-info-item:last-child {
    border-bottom: none;
  }
  
  .details-info-label {
    font-weight: 600;
    color: #495057;
    min-width: 140px;
    flex-shrink: 0;
    font-size: 0.9rem;
  }
  
  .details-info-value {
    color: #212529;
    flex: 1;
    word-break: break-word;
    font-size: 0.9rem;
  }
  
  @media (max-width: 768px) {
    .details-slider-panel {
      width: 100vw;
      right: -100vw;
    }
  }
`;

var Model = require("../information/model");

const Domain = () => {
  const dispatch = useDispatch();
  const { orgId } = useParams();
  const myRef = useRef(null);
  const [page, setPage] = useState(1);
  const [PageSize, setPerPage] = useState(10);

  const [filterData, setfilterData] = useState("all");
  const [domainFilter, setDomainFilter] = useState("all");
  const [search, setSearch] = useState("");
  const [category, setCategory] = useState("all");
  const [totalItems, setTotalItems] = useState(0);
  const [isModal, setModal] = useState("");
  const [forValue, setForValue] = useState("forever");
  const [lookalikeAppId, setLookalikeAppId] = useState([]);
  const [actionNote, setActionNote] = useState("");
  const [action, setAction] = useState("");
  const [selectedValue, setSelectedValue] = useState("pleaseSelect");
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [domains, setDomains] = useState([]);
  const [limit, setLimit] = useState(10);
  const [detailsModal, setDetailsModal] = useState(false);
  const [selectedRowDetails, setSelectedRowDetails] = useState(null);
  const [activeTab, setActiveTab] = useState('technologies');
  const [isRecommendationModal, setIsRecommendationModal] = useState(false);
  const [activeRecommendationTab, setActiveRecommendationTab] = useState('guide');
  const vendorName = sessionStorage.getItem('vendorName');
  const vendorId = sessionStorage.getItem('vendorId');
  const queryParameters = new URLSearchParams(window.location.search);
  const latest = queryParameters.get("latest");
  const auth = useSelector((state) => state?.auth?.user);
  const [isModalThree, setModalThree] = useState(false);
  const userPermission = useSelector(state => {
    return state?.auth?.user?.modulePermissionsConfig?.asm?.e;
  });
  const id = useSelector(state => {
    if (orgId) {
      return orgId;
    } else {
      return state?.summary?.localClient?._id || state?.summary?.clients?.[0]?._id;
    }
  }); const client = useSelector(
    (state) => state?.summary?.localClient || state?.summary?.clients?.[0]
  );

  let domain = client?.website?.replace(/^(?:https?:\/\/)?(?:www\.)?/i, "");
  if (domain?.charAt(domain.length - 1) == "/") {
    domain = [domain.substr(0, domain.length - 1)];
    // domain.unshift("all");
  } else {
    domain = [domain];
    // domain.unshift("all");
  }
  if (client?.domains && client.domains.length > 0) {
    domain = client.domains;
    // domain.unshift("all");
  }
  let dnsDetailsArray = useSelector(
    (state) => state?.subDomain?.subdomainDnsDetails?.data?.data
  );
  let dnsDetailsTotal = useSelector(
    (state) => state?.subDomain?.subdomainDnsDetails?.data
  );
  let activeInactive = useSelector(
    (state) => state?.subDomain?.subdomainDnsDetails
  );
  let oldDnsDetails = useSelector(
    (state) => state?.subDomain?.subDomainDetailGraph?.data

  );
  let totalCount = useSelector(
    (state) => state?.subDomain?.subDomainDetailTotal?.data
  );

  let scanCompleted = useSelector((state) => state?.subDomain?.scanCompleted);
  const addModal = () => {
    setModal("Form Wizard modal");
  };

  const [selectedIds, setSelectedIds] = useState([]);
  const [multiCheckTrue, setMultiCheckTrue] = useState(false);

  const multicheck = (data) => {
    const allIds = data?.map((item) => item._id);
    if (selectedIds.length > 0 || selectedIds.length == 0) {
      setMultiCheckTrue(true);
      setSelectedIds(allIds);
    }
    if (multiCheckTrue == true) {
      setSelectedIds([]);
      setMultiCheckTrue(false);
    }
  };

  const singleClick = (id, data) => {
    setSelectedIds((prevSelectedIds) => {
      if (prevSelectedIds.includes(id)) {
        return prevSelectedIds.filter((selectedId) => selectedId !== id);
      } else {
        return [...prevSelectedIds, id];
      }
    });
    if (selectedIds.length > 10) {
      setMultiCheckTrue(true);
    } else {
      setMultiCheckTrue(false);
    }
  };


  const snooze = (_id, event) => {
    if (event === "markAsRemidiated") {
      $.confirm({
        title: "Are you sure?",
        content: "Do you really want to mark this as remediated for the selected subdomains?",
        type: "green", // Customize the dialog type as needed
        buttons: {
          ok: {
            text: "Yes, Mark as Remediated",
            btnClass: "btn-success",
            keys: ["enter"],
            action: function () {
              let ids = [];
              ids.push(_id);
              const data = {
                action: "markAsRemidiated",
                subDomainIds: selectedIds.length === 0 ? ids : selectedIds,
                actionNote: "",
                for: "forever",
              };
              getSubDomainDetailsAction(
                id,
                dispatch,
                page,
                category,
                filterData,
                search,
                domainFilter,
                data
              );
              setSelectedValue("pleaseSelect");
              setActionNote("");
              setSelectedIds([]);
            },
          },
          cancel: function () {
            // User canceled, do nothing
          },
        },
      });
    }
  };

  const Unsnoozed = (_id) => {
    let ids = [];
    ids.push(_id);
    const data = {
      action: 'resetAction',
      subDomainIds: selectedIds == 0 ? ids : selectedIds,
    };
    getSubDomainDetailsAction(
      id, dispatch, page, category, filterData, search, domainFilter, data
    );
    setSelectedIds([]);
  }

    // Add these state variables to handle the date objects
    const [startDateObj, setStartDateObj] = useState(null);
    const [endDateObj, setEndDateObj] = useState(null);
  
    // Update startDateObj and endDateObj whenever startDate or endDate change
    useEffect(() => {
      if (startDate) {
        setStartDateObj(new Date(startDate));
      }
      if (endDate) {
        setEndDateObj(new Date(endDate));
      }
    }, [startDate, endDate]);
  

  const submit = () => {
    const data = {
      action: action,
      subDomainIds: selectedIds == 0 ? lookalikeAppId : selectedIds,
      actionNote: actionNote,
      for: forValue,
    };
    getSubDomainDetailsAction(
      id, dispatch, page, category, filterData, search, domainFilter, data
    );
    setModal("");
    setSelectedValue("pleaseSelect");
    setActionNote('');
    setSelectedIds([]);
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const statusParam = params.get('status');
    setfilterData(statusParam);
  }, []);

  useEffect(() => {
    if (orgId) {
      getSubDomainDetails(orgId, dispatch, page, category, filterData, search, domainFilter, startDate, endDate, limit);
    } else {
      getSubDomainDetails(id, dispatch, page, category, filterData, search, domainFilter, startDate, endDate, limit);
    }
  }, [id, dispatch, page, category, filterData, search, domainFilter, startDate, endDate, limit]);

  useEffect(() => {
    setTotalItems(dnsDetailsTotal?.totalDomains);
  }, [dnsDetailsTotal?.totalDomains]);

  useEffect(() => {
    getSubDomainDetailsGraph(id, dispatch)
  }, [id, dispatch])

  useEffect(() => {
    getSubDomainDetailsTotal(id, dispatch)
  }, [id, dispatch])

  //  let distinctFilter = ["All",'Active','InActive',"Latest"];
  let distinctFilter = ["all", "active", "inactive", "dangling"];

  let openPortArray = [];
  let ipArray = [];
  if (oldDnsDetails?.scanDetails) {
    for (let ip = 0; ip < oldDnsDetails?.scanDetails?.length; ip++) {
      ipArray.push(oldDnsDetails?.scanDetails?.[ip] || 0);
    }
  }

  const handleChange = (e) => {
    const fileReader = new FileReader();
    let fileType = e.target.files[0].type;
    // if (fileType != "application/json")
    //   toastr.error("Error", "Please upload json file.");

    Model.default.uploadSubdomain(e.target.files[0], id).then((response) => {
      if (!response.error) {
        toastr.success("Success", "Subdomain imported.");
        let logo = response.data;
        getSubDomainDetails(id, dispatch);
      }
    });
  };


  let clientName = "";

  if (JSON.parse(localStorage.getItem("OrgName"))) {
    if (sessionStorage.getItem('vendorId')) {
      clientName = sessionStorage.getItem('vendorName')
    } else {
      clientName = JSON.parse(localStorage.getItem("OrgName"));
    }
  }

  const downloadFile = async () => {
    try {
      const session = localStorage.getItem("session");
      axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
      const response = await axios.get(
        `https://api.brandsek.com/api/getSubDomainDetails/${id}/excel`,
        {
          responseType: "blob",
        }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${clientName?.replace(/\s+/g, '-')}Sub-Domain Details.xlsx`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      // console.error removed
    }
  };

  const removeKeyword = (index) => {
    let ip = [...domains];
    ip.splice(index, 1);
    setDomains(ip);
  }

  const addIps = () => {
    let val = $("#ips").val()
    setDomains([...domains, val])
    $("#ips").val('')
  }

  const submitDomains = () => {
    let domain = {
      "subDomains": domains
    }
    addSubdomains(id, domain)
    setModalThree('')
    setDomains([])
  }


  let mapData = dnsDetailsArray;

  mapData = mapData;

  let currentTableData = [];
  if (mapData && mapData.length > 0) {
    currentTableData = mapData;
  }

  const series = [
    totalCount?.totalActiveDomains || 0,
    totalCount?.totalInactivedomains || 0,
    totalCount?.totalDanglingDomains || 0,
  ];

  const labels = ["Active Subdomains", "Inactive Subdomains", "Dangling Subdomains"];

   // Add these new state variables
   const [datePickerOpen, setDatePickerOpen] = useState(false);
   const [tempStartDate, setTempStartDate] = useState(null);
   const [tempEndDate, setTempEndDate] = useState(null);
 
   // Update tempStartDate and tempEndDate whenever startDate or endDate change
   useEffect(() => {
     if (startDate) {
       setTempStartDate(new Date(startDate));
     }
     if (endDate) {
       setTempEndDate(new Date(endDate));
     }
   }, [startDate, endDate]);
 
   // Add this new function to format the displayed date range
   const formatDateRange = () => {
     if (startDate && endDate) {
       return `Selected date: ${startDate ? format(new Date(startDate), 'MM/dd/yyyy') : ''} to ${endDate ? format(new Date(endDate), 'MM/dd/yyyy') : ''}`;
     } else if (startDate) {
       return `From: ${startDate ? format(new Date(startDate), 'MM/dd/yyyy') : ''}`;
     } else if (endDate) {
       return `Till: ${endDate ? format(new Date(endDate), 'MM/dd/yyyy') : ''}`;
     }
     return "Select date range"; // Default placeholder text
   };
 
   // Add this function to handle applying the selected date range
   const applyDateRange = () => {
     if (tempStartDate) {
       setStartDate(format(tempStartDate, 'yyyy-MM-dd'));
     } else {
       setStartDate('');
     }
 
     if (tempEndDate) {
       setEndDate(format(tempEndDate, 'yyyy-MM-dd'));
     } else {
       setEndDate('');
     }
 
     setDatePickerOpen(false);
     setPage(1);
   };
 
   // Update the cancelDateSelection function to clear all dates
   const cancelDateSelection = () => {
     // Clear all date states when cancel is clicked
     setTempStartDate(null);
     setTempEndDate(null);
     setStartDate('');
     setEndDate('');
     setStartDateObj(null);
     setEndDateObj(null);
     setDatePickerOpen(false);
   };

  // Render DNS records grouped by type
  const renderDNSRecords = () => {
    if (!selectedRowDetails?.dnsDetails?.dnsRecords || selectedRowDetails.dnsDetails.dnsRecords.length === 0) {
      if (selectedRowDetails?.dnsDetails) {
        return (
          <div className="details-section">
            <div className="text-center p-4">
              <i className="fa fa-info-circle fa-3x text-muted mb-3"></i>
              <h6 className="text-muted">No DNS Records Found</h6>
              <p className="text-muted small">DNS records are not available for this subdomain.</p>
            </div>
          </div>
        );
      }
      return null;
    }

    // Group DNS records by type
    const groupedRecords = {};
    selectedRowDetails.dnsDetails.dnsRecords.forEach(record => {
      const type = record.dnsType || 'UNKNOWN';
      if (!groupedRecords[type]) {
        groupedRecords[type] = [];
      }
      groupedRecords[type].push(record);
    });

    const dnsTypes = Object.keys(groupedRecords);
    return (
      <>
        {/* DNS Overview Section */}
        {selectedRowDetails?.dnsDetails && (
          <div className="details-section">
            <div className="details-section-title">
              <i className="fa fa-info-circle"></i>
              DNS Overview
            </div>
            <div className="details-info-item">
              <span className="details-info-label">Status:</span>
              <span className="details-info-value">
                <span className={`badge ${selectedRowDetails.dnsDetails.status ? 'badge-success' : 'badge-danger'}`}>
                  {selectedRowDetails.dnsDetails.status ? 'Active' : 'Inactive'}
                </span>
              </span>
            </div>
            <div className="details-info-item">
              <span className="details-info-label">Domain Name:</span>
              <span className="details-info-value">{selectedRowDetails.dnsDetails.domainName || "N/A"}</span>
            </div>
            <div className="details-info-item">
              <span className="details-info-label">Query Time:</span>
              <span className="details-info-value">
                {selectedRowDetails.dnsDetails.queryTime 
                  ? moment(selectedRowDetails.dnsDetails.queryTime).format("DD-MM-YYYY HH:mm:ss")
                  : "N/A"}
              </span>
            </div>
            <div className="details-info-item">
              <span className="details-info-label">Domain Registered:</span>
              <span className="details-info-value">
                <span className={`badge ${selectedRowDetails.dnsDetails.domainRegistered ? 'badge-success' : 'badge-warning'}`}>
                  {selectedRowDetails.dnsDetails.domainRegistered ? 'Yes' : 'No'}
                </span>
              </span>
            </div>
            {selectedRowDetails.dnsDetails.dnsTypes && (
              <div className="details-info-item" style={{ flexDirection: "column", alignItems: "flex-start" }}>
                <span className="details-info-label" style={{ marginBottom: "8px" }}>DNS Types Found:</span>
                <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
                  {Object.keys(selectedRowDetails.dnsDetails.dnsTypes).map((type) => (
                    <span key={type} className="badge badge-info mr-1">
                      {type} ({selectedRowDetails.dnsDetails.dnsTypes[type]})
                    </span>
                  ))}
                </div>
              </div>
            )}
          </div>
        )}

        {/* DNS Records by Type */}
        {dnsTypes.map((dnsType) => (
          <div key={dnsType} className="details-section">
            <div className="details-section-title">
              <i className="fa fa-list"></i>
              {dnsType} Records ({groupedRecords[dnsType].length})
            </div>
            {groupedRecords[dnsType].map((record, index) => (
              <div key={index} className="details-info-item" style={{ flexDirection: "column", alignItems: "flex-start", padding: "12px 0", borderBottom: "1px solid #f1f3f5" }}>
                <div style={{ width: "100%" }}>
                  <div style={{ marginBottom: "8px" }}>
                    <strong>Name:</strong> {record.name || "N/A"}
                  </div>
                  <div style={{ marginBottom: "8px" }}>
                    <strong>TTL:</strong> {record.ttl || "N/A"}
                  </div>
                  {record.address && (
                    <div style={{ marginBottom: "8px" }}>
                      <strong>Address:</strong> <code style={{ backgroundColor: "#f8f9fa", padding: "2px 6px", borderRadius: "3px" }}>{record.address}</code>
                    </div>
                  )}
                  {record.singleName && (
                    <div style={{ marginBottom: "8px" }}>
                      <strong>Name Server:</strong> <code style={{ backgroundColor: "#f8f9fa", padding: "2px 6px", borderRadius: "3px" }}>{record.singleName}</code>
                    </div>
                  )}
                  {record.target && (
                    <div style={{ marginBottom: "8px" }}>
                      <strong>Target:</strong> <code style={{ backgroundColor: "#f8f9fa", padding: "2px 6px", borderRadius: "3px" }}>{record.target}</code>
                      {record.priority !== undefined && (
                        <span className="ml-2">
                          <strong>Priority:</strong> {record.priority}
                        </span>
                      )}
                    </div>
                  )}
                  {record.strings && record.strings.length > 0 && (
                    <div style={{ marginBottom: "8px" }}>
                      <strong>Value:</strong>
                      <div style={{ marginTop: "4px" }}>
                        {record.strings.map((str, strIndex) => (
                          <code key={strIndex} style={{ backgroundColor: "#f8f9fa", padding: "2px 6px", borderRadius: "3px", display: "block", marginBottom: "4px" }}>
                            {str}
                          </code>
                        ))}
                      </div>
                    </div>
                  )}
                  {record.host && (
                    <div style={{ marginBottom: "8px" }}>
                      <strong>Host:</strong> <code style={{ backgroundColor: "#f8f9fa", padding: "2px 6px", borderRadius: "3px" }}>{record.host}</code>
                    </div>
                  )}
                  {record.admin && (
                    <div style={{ marginBottom: "8px" }}>
                      <strong>Admin:</strong> <code style={{ backgroundColor: "#f8f9fa", padding: "2px 6px", borderRadius: "3px" }}>{record.admin}</code>
                    </div>
                  )}
                  {record.serial !== undefined && (
                    <div style={{ marginBottom: "8px" }}>
                      <strong>Serial:</strong> {record.serial}
                    </div>
                  )}
                  {record.refresh !== undefined && (
                    <div style={{ marginBottom: "8px" }}>
                      <strong>Refresh:</strong> {record.refresh}s
                    </div>
                  )}
                  {record.retry !== undefined && (
                    <div style={{ marginBottom: "8px" }}>
                      <strong>Retry:</strong> {record.retry}s
                    </div>
                  )}
                  {record.expire !== undefined && (
                    <div style={{ marginBottom: "8px" }}>
                      <strong>Expire:</strong> {record.expire}s
                    </div>
                  )}
                  {record.minimum !== undefined && (
                    <div style={{ marginBottom: "8px" }}>
                      <strong>Minimum:</strong> {record.minimum}s
                    </div>
                  )}
                  {record.rawText && (
                    <div style={{ marginTop: "8px", padding: "8px", backgroundColor: "#f8f9fa", borderRadius: "4px" }}>
                      <strong>Raw Text:</strong>
                      <pre style={{ margin: "4px 0 0 0", fontSize: "0.85em", whiteSpace: "pre-wrap", wordBreak: "break-all" }}>
                        {record.rawText}
                      </pre>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        ))}
      </>
    );
  };

  // Manage body scroll when details modal is open
  useEffect(() => {
    if (detailsModal) {
      document.body.classList.add('details-slider-open');
    } else {
      document.body.classList.remove('details-slider-open');
    }
    // Cleanup on unmount
    return () => {
      document.body.classList.remove('details-slider-open');
    };
  }, [detailsModal]);

  return (
    <>
      <style>{sliderStyles}</style>
      <div className="container-fluid">
        <AccessPage></AccessPage>
        <div className="block-header">
          <div className="row clearfix">
            <div className="col-md-6 col-sm-12">
              <h1 className="welcome-text">Subdomain Enumeration </h1>
              <nav aria-label="breadcrumb" className="mt-1">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    {vendorId ? <>
                      <Link to="/vendor"
                        onClick={(() => {
                          sessionStorage.clear();
                        })}
                      >Vendor Assessment</Link>
                    </> : <Link to="/" className="welcome-textSmall">Home</Link>}
                  </li>
                  {
                    vendorName ?
                      <li
                        className="breadcrumb-item active"
                        aria-current="page"
                        style={{ color: "white" }}
                      >
                        <Link to={`/dashboard/vendor/${vendorId}`}
                        >{vendorName}</Link>
                      </li> : ''
                  }
                  <li
                    className="breadcrumb-item active"
                    aria-current="page"
                    style={{ color: "white" }}
                  >
                    Subdomain Enumeration
                  </li>
                </ol>
              </nav>
            </div>
            <div className="col-md-6 col-sm-12 text-right hidden-xs d-flex justify-content-end">
              <span className="mr-2">
              <a
                onClick={(e) => {
                  e.preventDefault();
                  setIsRecommendationModal(true);
                }}
                href="#"
                className="btn btn-sm btn-primary mr-1"
                style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}
              >
                <i className="fa fa-lightbulb-o" style={{ fontSize: "14px" }}></i>
                Recommendation
              </a>
            </span>
              {mapData?.length === 0 ? null : (
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    downloadFile();
                  }}
                  href="/add-report"
                  className="btn btn-sm btn-primary mr-1 download-report"
                >
                  Download Details
                </a>
              )}
            </div>
          </div>
        </div>

        {typeof scanCompleted !== "undefined" && !scanCompleted && (
          <div className="card border-success">
            <ScanMessage />
          </div>
        )}

        <div className="row clearfix">
          <div className="col-lg-4 col-md-12">
            <div className="card RecordFoundCard">
              <div className="body" style={{ minHeight: "460px" }}>
                <h6 className="mb-3 welcome-textSmall">Records Found</h6>
                <div className="d-flex justify-content-center">
                  {series && series?.length > 0 && (
                    <PieChart series={series} label={labels} />
                  )}
                </div>
                <div className="form-group">
                  <label
                    className="d-block"
                    style={{ cursor: "pointer" }}
                    onClick={() => setfilterData("active")}
                  >
                    <span className="greenShadow"></span>
                    Active Subdomains{" "}
                    <span className="float-right">
                      {totalCount?.totalActiveDomains}
                    </span>
                  </label>
                  <div className="progress progress-xxs">
                    <div
                      className="progress-bar progress-bar-warning"
                      role="progressbar"
                      aria-valuemin="10"
                      aria-valuemax="100"
                      style={{}}
                    ></div>
                  </div>
                </div>
                <div className="form-group">
                  <label
                    className="d-block"
                    style={{ cursor: "pointer" }}
                    onClick={() => setfilterData("inactive")}
                  >
                    <span className="yellowShadow"></span>
                    Inactive Subdomains{" "}
                    <span className="float-right">
                      {totalCount?.totalInactivedomains}
                    </span>
                  </label>
                  <div className="progress progress-xxs">
                    <div
                      className="progress-bar progress-bar-warning"
                      role="progressbar"
                      aria-valuemin="0"
                      aria-valuemax="100"
                      style={{}}
                    ></div>
                  </div>
                </div>

                <div className="form-group mb-0">
                  <label
                    className="d-block"
                    style={{ cursor: "pointer" }}
                    onClick={() => setfilterData("dangling")}
                  >
                    <span className="redShadow"></span>
                    Dangling Subdomains{" "}
                    <span className="float-right">
                      {totalCount?.totalDanglingDomains}
                    </span>
                  </label>
                  <div className="progress progress-xxs">
                    <div
                      className="progress-bar progress-bar-warning"
                      role="progressbar"
                      aria-valuemin="10"
                      aria-valuemax="100"
                      style={{}}
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-8 col-md-12 col-sm-12">
            <div className="card">
              <div className="body" style={{ minHeight: "460px" }}>
                <h6 className="welcome-textSmall">Previous scan details</h6>
                {oldDnsDetails && (
                  <BasicLineColumn
                    dates={oldDnsDetails?.dates}
                    ipArray={oldDnsDetails?.scanDetails}
                    color={["#1DBF73"]}
                    yAxis="Records Found"
                  />
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="row clearfix">
          <div className="col-12 col-sm-12">
            <ul className="nav nav-tabs mb-2" id="myTabs" role="tablist">
              <li className="nav-item">
                <a
                  className={`nav-table-tab nav-link ${category === "all" ? "active" : ""
                    }`}
                  onClick={() => {
                    setCategory("all");
                    setPage(1);
                    setfilterData("all");
                    setDomainFilter('all')
                    setSearch("");
                    setSelectedIds([]);
                  }}
                >
                  Current
                </a>
              </li>
              <li className="nav-item">
                <a
                  className={`nav-link nav-table-tab ${category === "risk-accepted" ? "active" : ""
                    }`}
                  onClick={() => {
                    setCategory("risk-accepted");
                    setPage(1);
                    setfilterData("all");
                    setDomainFilter('all')
                    setSearch("");
                    setSelectedIds([]);
                  }}
                >
                  Risk Accepted
                </a>
              </li>
              <li className="nav-item">
                <a
                  className={`nav-link nav-table-tab ${category === "false-positive" ? "active" : ""
                    }`}
                  onClick={() => {
                    setCategory("false-positive");
                    setPage(1);
                    setfilterData("all");
                    setDomainFilter('all')
                    setSearch("");
                    setSelectedIds([]);
                  }}
                >
                  False Positive
                </a>
              </li>
              <li className="nav-item">
                <a
                  className={`nav-link nav-table-tab ${category === "remidiated" ? "active" : ""
                    }`}
                  onClick={() => {
                    setCategory("remidiated");
                    setPage(1);
                    setfilterData("all");
                    setDomainFilter('all')
                    setSearch("");
                    setSelectedIds([]);
                  }}
                >
                  Remediated
                </a>
              </li>
            </ul>
            <div className="card card_tableBox">
              <div className="body">
                <div className="row" ref={myRef}>
                  <div className="col-sm-3 mb-2">
                    <select
                      className="custom-select custom-select-sm form-control form-control-sm"
                      value={filterData}
                      onChange={(e) => { setfilterData(e.target.value); setPage(1) }}
                    >
                      {distinctFilter?.map((row) => {
                        return (
                          <option value={row}>{row?.toUpperCase()}</option>
                        );
                      })}
                    </select>
                  </div>
                  <div className="col-sm-3 mb-2">
                    <div className="date-picker-container">
                      <div className="date-range-input">
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          placeholder="Select date range"
                          value={formatDateRange()}
                          onClick={() => setDatePickerOpen(true)}
                          readOnly
                        />
                        <span className="calendar-icon">
                          <i className="fa fa-calendar" aria-hidden="true"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-3 mb-2">
                    <select
                      className="custom-select custom-select-sm form-control form-control-sm"
                      value={domainFilter}
                      onChange={(e) => { setDomainFilter(e.target.value); setPage(1) }}
                    >
                      <option value="all">All Domains</option>
                      {domain?.map((row, index) => {
                        return (
                          <option value={row}>{row?.toUpperCase()}</option>
                        );
                      })}
                    </select>
                  </div>
                  <div className="col-sm-3 mb-2">
                   <div className="searchBoxInput p-0">
                      <input
                        class="form-control form-control-sm ml-0 my-1"
                        type="text"
                        placeholder="Search"
                        aria-label="Search"
                        value={search}
                        onChange={(e) => {
                          setSearch(e.target.value);
                          setPage(1);
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-sm-3 mb-2">
                    {selectedIds.length > 1 && userPermission && category === "all" && (
                      <Box sx={{ width: 160 }}>
                        <FormControl fullWidth>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={selectedValue}
                            onChange={(event) => {
                              setAction(event.target.value);
                              snooze("", event.target.value);
                            }}
                          >
                            <MenuItem value="pleaseSelect">
                              Snooze Options
                            </MenuItem>
                            <MenuItem
                              value="riskAccepted"
                              onClick={() => {
                                addModal();
                              }}
                            >
                              Risk Accepted
                            </MenuItem>
                            <MenuItem
                              value="markAsFalsePositive"
                              onClick={() => {
                                addModal();
                              }}
                            >
                              False Positive
                            </MenuItem>
                            <MenuItem value="markAsRemidiated">
                              Remediated
                            </MenuItem>
                          </Select>
                        </FormControl>
                      </Box>
                    )}
                    {selectedIds.length > 1 &&
                      (category == "false-positive" ||
                        category == "risk-accepted") && (
                        <button
                          className="btn btn-primary btn-sm mr-1 Unsnooze mb-2"
                          onClick={() => Unsnoozed("")}
                        >
                          Unsnooze
                        </button>
                      )}
                  </div>
                </div>
                <div className="table-responsive invoice_list mb-4">
                  <table className="table table-custom spacing5 mb-0">
                    <thead>
                      <tr>
                        {auth?.accessLevel != "Threat Analyst" && (category === "all" ||
                          category === "risk-accepted" ||
                          category === "false-positive") && (
                            <th>
                              <input
                                type="checkbox"
                                checked={
                                  selectedIds == 0 ? false : multiCheckTrue
                                }
                                onClick={() => {
                                  multicheck(currentTableData);
                                }}
                                className="checkUncheck"
                              />
                            </th>
                          )}
                        {/* <th>#No</th> */}
                        {/* <th>Status</th> */}
                        <th>Status</th>
                        <th>Domain Name</th>
                        {/* <th>Record Type</th> */}
                        <th>IP Address</th>
                        {/* <th>Service</th> */}
                        <th>Created At</th>
                        <th style={{ textAlign: "center" }}>Updated At</th>
                        <th>Details</th>
                        {category !== "all" && <th>Action Note</th>}
                        {auth?.accessLevel != "Threat Analyst" && userPermission && (category === "all" ||
                          category === "risk-accepted" ||
                          category === "false-positive") && (
                            <th style={{ width: "80" }}>Action</th>
                          )}
                      </tr>
                    </thead>
                    <tbody>
                      {currentTableData?.map((row, index) => {
                        const pageCount = (page - 1) * 10 + 1;

                        return (
                          <tr>
                            {auth?.accessLevel != "Threat Analyst" && (category === "all" ||
                              category === "risk-accepted" ||
                              category === "false-positive") && (
                                <td>
                                  <input
                                    onClick={() => singleClick(row?._id)}
                                    checked={selectedIds?.includes(
                                      row?._id
                                    )}
                                    type="checkbox"
                                    className="checkUncheck"
                                  />
                                </td>
                              )}
                            {/* <td>{pageCount + index}</td> */}
                            <td style={{ whiteSpace: "unset" }}>
                              <span
                                className={
                                  row?.isDangling == true
                                    ? "badge badge-warning"
                                    : row?.isActive == true
                                      ? "badge badge-success"
                                      : "badge badge-danger"
                                }
                              >
                                {row?.isDangling == true
                                  ? "Dangling"
                                  : row?.isActive == true
                                    ? "Active"
                                    : "In Active"}
                              </span>
                            </td>
                            {/* <td>
                            {row?.techStack?.urls?.[
                                  `https://${row?.subDomainName}/`
                                ]?.status || "NA"}
                          </td> */}

                            <td style={{ whiteSpace: "unset", color: "white" }}>
                              <a
                                href={`https://${row?.subDomainName}`}
                                target="_blank"
                                style={{ color: "white" }}
                              >
                                {`${row?.subDomainName}`}
                              </a>
                            </td>
                            {/* <td>{row?.recordType}</td> */}
                            <td style={{ whiteSpace: "unset" }}>
                              {row?.ip}
                            </td>
                            {/* <td style={{ whiteSpace: "unset" }}>
                              {row?.server
                                ? row?.server
                                : row?.serverName}
                            </td> */}
                            <td style={{ whiteSpace: "unset" }}>
                              {moment(row?.createdAt).format(
                                "DD-MM-YYYY"
                              )}
                            </td>
                            <td
                              style={{ whiteSpace: "unset", textAlign: "center" }}
                            >
                              {moment(row?.updatedAt).format(
                                "DD-MM-YYYY"
                              )}
                            </td>
                            <td>
                              <button
                                className="btn btn-sm"
                                onClick={() => {
                                  setSelectedRowDetails(row);
                                  setDetailsModal(true);
                                  setActiveTab('technologies');
                                }}
                                style={{
                                  backgroundColor: "#17a2b8",
                                  borderColor: "#17a2b8",
                                  color: "#fff",
                                  borderRadius: "4px",
                                  padding: "4px 12px",
                                  transition: "all 0.3s ease",
                                  display: "inline-flex",
                                  alignItems: "center",
                                  gap: "6px"
                                }}
                                onMouseEnter={(e) => {
                                  e.target.style.backgroundColor = "#138496";
                                  e.target.style.borderColor = "#117a8b";
                                  e.target.style.transform = "translateY(-1px)";
                                  e.target.style.boxShadow = "0 2px 4px rgba(0,0,0,0.2)";
                                }}
                                onMouseLeave={(e) => {
                                  e.target.style.backgroundColor = "#17a2b8";
                                  e.target.style.borderColor = "#17a2b8";
                                  e.target.style.transform = "translateY(0)";
                                  e.target.style.boxShadow = "none";
                                }}
                              >
                                <i className="fa fa-info-circle" style={{ fontSize: "14px" }}></i>
                                <span className="details-slider-action-btn-text">Details</span>
                              </button>
                            </td>
                            {category !== "all" && <td style={{ whiteSpace: "unset" }}>{row?.actionNote ? row.actionNote : "N/A"}</td>}
                            {auth?.accessLevel != "Threat Analyst" && userPermission && category === "all" && (
                              <td>
                                <Box sx={{ width: 160 }}>
                                  <FormControl fullWidth>
                                    {/* <InputLabel
                                          sx={{ color: "#fff" }}
                                          id="demo-simple-select-label"
                                        >
                                          Action
                                        </InputLabel> */}
                                    <Select
                                      labelId="demo-simple-select-label"
                                      id="demo-simple-select"
                                      value={selectedValue}
                                      onChange={(event) => {
                                        setAction(event.target.value);
                                        snooze(row?._id, event.target.value);
                                      }}
                                    >
                                      <MenuItem value="pleaseSelect">
                                        Snooze Options
                                      </MenuItem>
                                      <MenuItem
                                        value="riskAccepted"
                                        onClick={() => {
                                          addModal();
                                          setLookalikeAppId([row._id]);
                                        }}
                                      >
                                        Risk Accepted
                                      </MenuItem>
                                      <MenuItem
                                        value="markAsFalsePositive"
                                        onClick={() => {
                                          addModal();
                                          setLookalikeAppId([row._id]);
                                        }}
                                      >
                                        False Positive
                                      </MenuItem>
                                      <MenuItem value="markAsRemidiated">
                                        Remediated
                                      </MenuItem>
                                    </Select>
                                  </FormControl>
                                </Box>
                              </td>
                            )}
                            {auth?.accessLevel != "Threat Analyst" && userPermission && (category === "risk-accepted" || category === "false-positive") && (
                              <td>
                                <button
                                  className="btn btn-primary btn-sm mr-1 Unsnooze mb-2"
                                  onClick={() => Unsnoozed(row?._id)}
                                >
                                  Unsnooze
                                </button>
                              </td>
                            )}
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
                <div className="d-flex justify-content-between align-content-center">
                  <div className="dataTables_paginate">
                    {totalItems > 0 && (
                      <Pagination
                        className="pagination-bar"
                        currentPage={page}
                        totalCount={totalItems}
                        pageSize={limit}
                        onPageChange={(page) =>
                          setPage(page
                          )}
                      />
                    )}
                  </div>
                  {totalItems > 10 && (
                    <select
                      value={limit}
                      onChange={(e) => {
                        setLimit(e.target.value)
                      }}
                      className="form-control limitSelectBox"
                    >
                      <option value={10}>10 per page</option>
                      <option value={25}>25 per page</option>
                      <option value={50}>50 per page</option>
                      <option value={100}>100 per page</option>
                    </select>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className={`modal fade Form-Wizard-modal ${isModal === "Form Wizard modal" ? "d-block show" : ""
            }`}
        >
          <div className="modal-dialog modal-lg" id="clientModal">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  {action == "markAsFalsePositive"
                    ? "Mark As False Positive"
                    : "Risk Accepted"}
                </h5>
                <button
                  type="button"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    setModal("");
                    setActionNote('');
                  }}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body pricing_page modal_mob">
                <div className="col-xl-12 col-lg-12 col-md-12">
                  <div className="card">
                    <div className="row clearfix">
                      <div className="col-md-12">
                        <label className="col-lg-6 col-md-12">Snooze for</label>
                        <div className="form-group ol-lg-12 col-md-12">
                          <select
                            className="custom-select custom-select-sm form-control form-control-sm"
                            onChange={(e) => setForValue(e.target.value)}
                          >
                            <option value="forever">Forever</option>
                            <option value="3 months">3 Months</option>
                            <option value="6 months">6 Months</option>
                            <option value="12 months">12 Months</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <label className="col-lg-12 col-md-12">Detail</label>
                        <div className="form-group col-lg-12 col-md-12">
                          <textarea
                            onChange={(e) => setActionNote(e.target.value)}
                            value={actionNote}
                            className="form-control"
                            rows="3"
                          ></textarea>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div
                        className="col-lg-12 col-md-12"
                        style={{ marginRight: "28px" }}
                      >
                        <button
                          type="button"
                          style={{ color: "black", fontWeight: "bold" }}
                          onClick={submit}
                          className="btn btn-round btn-primary mr-1 pull-right"
                        >
                          Submit
                        </button>
                        &nbsp;&nbsp;
                        <button
                          type="button"
                          onClick={() => {
                            setModal("");
                            setActionNote('');
                          }}
                          className="btn btn-round btn-default pull-right"
                          style={{ marginRight: "10px" }}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className={`modal fade Form-Wizard-modal ${isModalThree === "Form Wizard modalThree" ? "d-block show" : ""
            }`}
        >
          <div className="modal-dialog modal-lg" id="clientModal">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Add Subdomain
                </h5>
                <button
                  type="button"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    setModalThree("");
                    setDomains([]);
                  }}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body pricing_page">
                <div className="col-xl-12 col-lg-12 col-md-12">
                  <div className="card">
                    <div className="row clearfix">
                      <div className="col-md-12">
                        <div className="form-group d-flex">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Subdomains"
                            name="ips"
                            id="ips"
                            style={{ float: "left", width: "89%" }}
                          />
                          <button
                            type="button"
                            style={{ float: "left", marginLeft: '5px' }}
                            className="btn btn-primary"
                            onClick={() => addIps()}
                          >
                            <i
                              className="fa fa-plus"
                              style={{ fontSize: "22px", color: "black" }}
                            ></i>
                          </button>
                        </div>
                        {domains && domains.length > 0 && (
                          <div className="row">
                            {domains?.map((keyword, index) => {
                              return (
                                <label
                                  key={index}
                                  style={{
                                    color: "white",
                                    background: "#43a5f5",
                                    padding: "4px 6px",
                                    margin: "5px 5px"
                                  }}
                                >
                                  <span style={{ display: 'inline-block', textAlign: 'center', padding: '0px 8px' }}>
                                    {keyword}{" "}
                                    <span
                                      className="fa fa-times-circle"
                                      onClick={() => removeKeyword(index)}
                                      style={{ cursor: 'pointer' }}
                                    ></span>
                                  </span>

                                </label>
                              );
                            })}
                          </div>)}
                      </div>
                      <div className="col-md-12 text-center">
                        <button
                          type="button"
                          style={{ color: "black", fontWeight: "bold" }}
                          className="btn btn-round btn-primary mr-1"
                          onClick={() => {
                            submitDomains()
                          }}
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
              {/* Move date picker outside of the component tree to ensure proper rendering */}
      {datePickerOpen && (
        <div className="date-range-overlay" onClick={() => setDatePickerOpen(false)}>
          <div className="date-range-picker-popup" onClick={(e) => e.stopPropagation()}>
            <div className="date-range-picker-header">
              {tempStartDate && tempEndDate
                ? `Selected date: ${format(tempStartDate, 'MM/dd/yyyy')} to ${format(tempEndDate, 'MM/dd/yyyy')}`
                : "Select date range"}
            </div>
            <div className="date-range-calendars">
              <div>
                <h6>From</h6>
                <DatePicker
                  selected={tempStartDate}
                  onChange={(date) => {
                    setTempStartDate(date);
                    if (tempEndDate && date > tempEndDate) {
                      setTempEndDate(null);
                    }
                  }}
                  selectsStart
                  startDate={tempStartDate}
                  endDate={tempEndDate}
                  inline
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                />
              </div>
              <div>
                <h6>To</h6>
                <DatePicker
                  selected={tempEndDate}
                  onChange={(date) => setTempEndDate(date)}
                  selectsEnd
                  startDate={tempStartDate}
                  endDate={tempEndDate}
                  minDate={tempStartDate}
                  inline
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                />
              </div>
            </div>
            <div className="date-range-actions">
              <button
                className="date-range-apply"
                onClick={applyDateRange}
              >
                Apply Filter
              </button>
              <button
                className="date-range-cancel"
                onClick={cancelDateSelection}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Subdomain Details Slider */}
      <div
        className={`details-slider-overlay ${detailsModal ? "show" : ""}`}
        onClick={() => {
          setDetailsModal(false);
          setSelectedRowDetails(null);
          setActiveTab('technologies');
        }}
      ></div>
      <div className={`details-slider-panel ${detailsModal ? "open" : ""}`}>
        <div className="details-slider-content">
          <div className="details-slider-header">
            <h5 style={{ color: "white", margin: 0 }}>
              <i className="fa fa-server mr-2"></i>
              Subdomain Details
              {selectedRowDetails?.subDomainName && (
                <span className="ml-2" style={{ fontSize: "0.85em", opacity: 0.9, color: "white" }}>
                  - {selectedRowDetails.subDomainName}
                </span>
              )}
            </h5>
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <button
                type="button"
                className="details-slider-close"
                onClick={() => {
                  setDetailsModal(false);
                  setSelectedRowDetails(null);
                  setActiveTab('technologies');
                }}
                aria-label="Close"
              >
                <i className="fa fa-times"></i>
              </button>
            </div>
          </div>
          <div className="details-slider-tabs">
            <button
              className={`details-slider-tab ${activeTab === 'technologies' ? 'active' : ''}`}
              onClick={() => setActiveTab('technologies')}
            >
              <i className="fa fa-cogs mr-2"></i>
              Technologies
            </button>
            <button
              className={`details-slider-tab ${activeTab === 'dns' ? 'active' : ''}`}
              onClick={() => setActiveTab('dns')}
            >
              <i className="fa fa-server mr-2"></i>
              DNS Details
            </button>
          </div>
          <div className="details-slider-body">
            {selectedRowDetails && (
              <>
                {activeTab === 'technologies' && (
                  <>
                    {/* Technologies Section */}
                    <div className="details-section">
                      <div className="details-section-title">
                        <i className="fa fa-cogs"></i>
                        Technologies & Services
                      </div>
                      {selectedRowDetails?.service && selectedRowDetails.service.length > 0 ? (
                        <div className="details-info-item" style={{ flexDirection: "column", alignItems: "flex-start" }}>
                          <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", width: "100%" }}>
                            {selectedRowDetails.service.map((service, index) => (
                              <span key={index} className="badge badge-info mr-1 mb-2" style={{ fontSize: "0.9rem", padding: "6px 12px" }}>
                                {service}
                              </span>
                            ))}
                          </div>
                        </div>
                      ) : (
                        <div className="details-info-item">
                          <span className="details-info-value text-muted">No technologies or services detected.</span>
                        </div>
                      )}
                    </div>

                    {/* Vulnerability Summary */}
                    {/* {(selectedRowDetails?.totalCriticalVulnerabilities !== undefined || 
                      selectedRowDetails?.totalHighVulnerabilities !== undefined ||
                      selectedRowDetails?.totalMediumVulnerabilities !== undefined ||
                      selectedRowDetails?.totalLowVulnerabilities !== undefined) && (
                      <div className="details-section">
                        <div className="details-section-title">
                          <i className="fa fa-shield-alt"></i>
                          Vulnerability Summary
                        </div>
                        <div className="details-info-item">
                          <span className="details-info-label">Critical:</span>
                          <span className="details-info-value">
                            <span className="badge badge-danger">
                              {selectedRowDetails.totalCriticalVulnerabilities || 0}
                            </span>
                          </span>
                        </div>
                        <div className="details-info-item">
                          <span className="details-info-label">High:</span>
                          <span className="details-info-value">
                            <span className="badge badge-warning">
                              {selectedRowDetails.totalHighVulnerabilities || 0}
                            </span>
                          </span>
                        </div>
                        <div className="details-info-item">
                          <span className="details-info-label">Medium:</span>
                          <span className="details-info-value">
                            <span className="badge badge-info">
                              {selectedRowDetails.totalMediumVulnerabilities || 0}
                            </span>
                          </span>
                        </div>
                        <div className="details-info-item">
                          <span className="details-info-label">Low:</span>
                          <span className="details-info-value">
                            <span className="badge badge-secondary">
                              {selectedRowDetails.totalLowVulnerabilities || 0}
                            </span>
                          </span>
                        </div>
                      </div>
                    )} */}

                    {/* Basic Information */}
                    <div className="details-section">
                      <div className="details-section-title">
                        <i className="fa fa-info-circle"></i>
                        Basic Information
                      </div>
                      <div className="details-info-item">
                        <span className="details-info-label">Subdomain:</span>
                        <span className="details-info-value">
                          <a href={`https://${selectedRowDetails.subDomainName}`} target="_blank" rel="noopener noreferrer" style={{ color: "#17a2b8" }}>
                            {selectedRowDetails.subDomainName || "N/A"}
                          </a>
                        </span>
                      </div>
                      <div className="details-info-item">
                        <span className="details-info-label">IP Address:</span>
                        <span className="details-info-value">
                          <code style={{ backgroundColor: "#f8f9fa", padding: "2px 6px", borderRadius: "3px" }}>
                            {selectedRowDetails.ip || "N/A"}
                          </code>
                        </span>
                      </div>
                      <div className="details-info-item">
                        <span className="details-info-label">Status:</span>
                        <span className="details-info-value">
                          <span className={`badge ${
                            selectedRowDetails.isDangling ? "badge-warning" :
                            selectedRowDetails.isActive ? "badge-success" : "badge-danger"
                          }`}>
                            {selectedRowDetails.isDangling ? "Dangling" :
                             selectedRowDetails.isActive ? "Active" : "Inactive"}
                          </span>
                        </span>
                      </div>
                      <div className="details-info-item">
                        <span className="details-info-label">Server:</span>
                        <span className="details-info-value">
                          {selectedRowDetails.server || selectedRowDetails.serverName || "N/A"}
                        </span>
                      </div>
                      <div className="details-info-item">
                        <span className="details-info-label">Created At:</span>
                        <span className="details-info-value">
                          {selectedRowDetails.createdAt 
                            ? moment(selectedRowDetails.createdAt).format("DD-MM-YYYY HH:mm:ss")
                            : "N/A"}
                        </span>
                      </div>
                      <div className="details-info-item">
                        <span className="details-info-label">Updated At:</span>
                        <span className="details-info-value">
                          {selectedRowDetails.updatedAt 
                            ? moment(selectedRowDetails.updatedAt).format("DD-MM-YYYY HH:mm:ss")
                            : "N/A"}
                        </span>
                      </div>
                    </div>
                  </>
                )}
                {activeTab === 'dns' && (
                  <>
                    {renderDNSRecords()}
                  </>
                )}
              </>
            )}
          </div>
        </div>
      </div>
      </div>

      {/* Recommendation Modal */}
      {isRecommendationModal && (
        <div className="recommendation-modal-overlay" onClick={() => setIsRecommendationModal(false)}>
          <div className="recommendation-modal-container" onClick={(e) => e.stopPropagation()}>
            <button className="recommendation-modal-close" onClick={() => setIsRecommendationModal(false)}>
              &times;
            </button>
            
            <div className="recommendation-modal-content">
              <div className="recommendation-tabs">
                <button
                  className={`recommendation-tab ${activeRecommendationTab === 'guide' ? 'active' : ''}`}
                  onClick={() => setActiveRecommendationTab('guide')}
                >
                  Guidance
                </button>
                <button
                  className={`recommendation-tab ${activeRecommendationTab === 'checklist' ? 'active' : ''}`}
                  onClick={() => setActiveRecommendationTab('checklist')}
                >
                  Action Checklist
                </button>
              </div>

              {/* GUIDANCE TAB */}
              <div className={`recommendation-tab-content ${activeRecommendationTab === 'guide' ? 'active' : ''}`}>
                <div className="guide-intro">
                  BrandSek has identified multiple active and inactive subdomains associated with
                  your organization. Unmonitored subdomains significantly expand the external
                  attack surface and can lead to subdomain takeover, data exposure, and shadow IT risks.
                </div>

                <details className="checklist-details" open>
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>What Is Subdomain Monitoring</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <p>
                      Subdomain monitoring continuously discovers, tracks, and classifies subdomains
                      linked to your primary domains, including active, inactive, and dangling entries.
                      Attackers actively target forgotten or misconfigured subdomains.
                    </p>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Key Risk Categories Observed</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li><strong>Active subdomains:</strong> Production systems exposed to the internet</li>
                      <li><strong>Inactive subdomains:</strong> Abandoned services still resolving in DNS</li>
                      <li><strong>Dangling subdomains:</strong> DNS entries pointing to decommissioned cloud resources</li>
                      <li><strong>Third-party hosted subdomains:</strong> SaaS, CDN, or vendor infrastructure</li>
                    </ul>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Security & Business Impact</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Subdomain takeover via cloud service reassignment</li>
                      <li>Unauthorized hosting of phishing or malware pages</li>
                      <li>Exposure of internal admin panels or test environments</li>
                      <li>Compliance violations due to unmanaged internet-facing assets</li>
                      <li>Increased attack surface for automated scanners and bots</li>
                    </ul>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Threat Landscape Insight</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <p>
                      Threat actors routinely scan DNS records to identify inactive or dangling
                      subdomains. Once identified, these are exploited to host phishing kits,
                      credential harvesters, or brand impersonation pages.
                    </p>
                  </div>
                </details>
              </div>

              {/* CHECKLIST TAB */}
              <div className={`recommendation-tab-content ${activeRecommendationTab === 'checklist' ? 'active' : ''}`}>
                <details className="checklist-details" open>
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Immediate Risk Reduction</h3>
                      <span className="severity-badge high">High</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Review all inactive subdomains for business necessity</li>
                      <li>Remove DNS records for unused or deprecated subdomains</li>
                      <li>Identify and remediate dangling subdomains immediately</li>
                    </ul>
                    <div className="compliance-tag">ISO 27001 A.8.9 · Asset Management</div>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Subdomain Takeover Prevention</h3>
                      <span className="severity-badge high">High</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Verify cloud resources linked to DNS records exist</li>
                      <li>Reclaim or delete orphaned cloud services</li>
                      <li>Restrict wildcard DNS usage where possible</li>
                    </ul>
                    <div className="compliance-tag">OWASP Top 10 – Security Misconfiguration</div>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Operational Hardening</h3>
                      <span className="severity-badge medium">Medium</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Tag subdomains by environment (Prod / UAT / Dev)</li>
                      <li>Ensure TLS certificates for active subdomains</li>
                      <li>Disable directory listing and default pages</li>
                    </ul>
                    <div className="compliance-tag">NIST CSF PR.AC</div>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Continuous Monitoring & Governance</h3>
                      <span className="severity-badge low">Low</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Enable continuous subdomain discovery</li>
                      <li>Track changes in IP, hosting, and DNS resolution</li>
                      <li>Periodically validate ownership of all subdomains</li>
                    </ul>
                    <div className="compliance-tag">CERT-In Continuous Attack Surface Monitoring</div>
                  </div>
                </details>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Domain;
